import styles from './Table.module.scss';
interface Props {
  totals: any[];
}
const TableTotal = ({ totals }: Props): JSX.Element => {
  return (
    <tr className={styles.totalRow}>
      {totals.length &&
        totals.map((total, i) => {
          return <td key={i}>{total}</td>;
        })}
    </tr>
  );
};

export default TableTotal;
